export default "__VITE_ASSET__GTIq3t3l__"